import React, {useEffect, useState} from "react";
import {OrganizationUnitHierarchyBreadcrumbs} from "../components/organization-unit-hierarchy-breadcrumb/OrganizationUnitHierarchyBreadcrumbs";
import {Navigate, useNavigate, useParams} from "react-router-dom";
import {makeStyles} from "@material-ui/core/styles";
import {WithOrganization} from "../components/organizations/organization-context";
import {ArrowBackIos} from "@material-ui/icons";
import Button from "@material-ui/core/Button";
import {StyledSubscriptionAssignementEditor} from "../components/subscription-assignment/SubscriptionAssignmentEditor"
import {run} from "../utils/function-util";
import {getSubscriptionsCount} from "../api/organization-unit-functions";
import {SubscriptionCount} from "../models/subscription-model";

const useStyles = makeStyles(theme => ({
    orgUnitDetail: {
        margin: theme.spacing(4),
        '& > *': {
            'margin-bottom': theme.spacing(4)
        }
    },
    top: {
        display: 'flex',
        flexDirection: 'row',
        flexGrow: 1,
        alignItems: 'center'
    }
}));

export const SubscriptionAssignment: React.FC<WithOrganization> = ({currentOrganization}) => {
    const classes = useStyles();
    const {organizationUnitId} = useParams<{ organizationUnitId: string }>();
    const navigate = useNavigate();
    const [subscriptionCounts, setSubscriptionCounts] = useState<SubscriptionCount[]>([]);

    useEffect(run(
        !!currentOrganization && !!organizationUnitId ? getSubscriptionsCount(currentOrganization.id, parseInt(organizationUnitId)) : [],
        (counts: SubscriptionCount[]) => {
            if (!!currentOrganization.id && organizationUnitId) {
                setSubscriptionCounts(counts);
            }
        }), [organizationUnitId]);

    if (!organizationUnitId) {
        return <Navigate to='/organization-units' replace={false}/>;
    }

    const goBack = () => {
        navigate(`/organization-units/${organizationUnitId}/detail`);
    };

    return (
        <div className={classes.orgUnitDetail}>
            <div className={classes.top}>
                <Button onClick={goBack}>
                    <ArrowBackIos color="primary"/>
                </Button>
                <OrganizationUnitHierarchyBreadcrumbs organizationId={currentOrganization.id}
                                                      organizationUnitId={organizationUnitId}/>
            </div>

            {subscriptionCounts.length > 0 &&
            <StyledSubscriptionAssignementEditor organizationId={currentOrganization.id}
                                          organizationUnitId={organizationUnitId}
                                          subscriptionCounts={subscriptionCounts}
                                          onDone={goBack}/>}
        </div>
    )
};
